<template>
	<div>
		<div v-if="isLoading">
			<LoadingState />
		</div>
		<div v-if="!isLoading">
			<NavBar />
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/elements/NavBar';
import LoadingState from '@/components/elements/LoadingState';

export default {
	components: {
		NavBar,
		LoadingState,
	},
	computed: {
		...mapGetters(['currentUser', 'isLoading']),
	},
	methods: {
		logout() {
			this.$router.push('/logout');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/layouts/ApplicationChrome.vue